import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Legal: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">特定商取引法に基づく表記</h1>

          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">販売事業者</h2>
              <p className="text-gray-600">ForceAI</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">代表者</h2>
              <p className="text-gray-600">安田 陸</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">所在地</h2>
              <p className="text-gray-600">〒107-0062 東京都港区南青山3丁目1番36号青山丸竹ビル6F</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">電話番号</h2>
              <p className="text-gray-600">ご請求があった際に、遅滞なく開示いたします</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">メールアドレス</h2>
              <p className="text-gray-600">yasuda_riku@forceai.jp</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">商品の名称</h2>
              <p className="text-gray-600">RepliGo（レプリゴ）</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">商品の価格</h2>
              <p className="text-gray-600">
                料金プランの詳細については、<a href="#pricing" onClick={(e) => handleSectionClick(e, 'pricing')} className="text-blue-600 hover:text-blue-800">料金ページ</a>をご参照ください。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">商品代金以外の必要料金</h2>
              <p className="text-gray-600">インターネット接続料金、通信料金等はお客様のご負担となります。</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">引き渡し時期</h2>
              <p className="text-gray-600">お申し込み完了後、即時にご利用いただけます。</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">お支払い方法</h2>
              <p className="text-gray-600">
                クレジットカード（Stripe決済）
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">支払時期</h2>
              <p className="text-gray-600">
                初回申込時および契約更新ごとに自動で課金されます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">返品・キャンセルについて</h2>
              <p className="text-gray-600">
                本サービスはデジタルコンテンツのため、ご購入後の返品・キャンセルはお受けできません。
                ただし、法令に基づく返品・キャンセルはこの限りではありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">解約について</h2>
              <p className="text-gray-600">
                Stripeカスタマーポータルから、いつでも解約可能です。解約後は次回以降の課金は行われません。
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Legal; 